import { ChevronLeft, ChevronRight } from "../../assets/icons";
import Button from "../button";
import LogoutNavDesktop from "./navbarComponents/LogoutNavDesktop";
const { dateLong, datePeriodLabel } = require("../../utils/Date");

const DAY_MS = 24 * 60 * 60 * 1000;

const NavbarSite = ({ type, dateStart, setDateStart, dateEnd, setDateEnd }) => {
  const periodDays =
    dateStart && dateEnd
      ? Math.round((new Date(dateEnd) - new Date(dateStart)) / DAY_MS) + 1
      : 1;

  const onPrevPeriod = () => {
    if (!dateStart || !dateEnd) return;
    const shiftMs = periodDays * DAY_MS;
    setDateStart(new Date(dateStart.getTime() - shiftMs));
    setDateEnd(new Date(dateEnd.getTime() - shiftMs));
  };

  const onNextPeriod = () => {
    if (!dateStart || !dateEnd) return;
    const shiftMs = periodDays * DAY_MS;
    setDateStart(new Date(dateStart.getTime() + shiftMs));
    setDateEnd(new Date(dateEnd.getTime() + shiftMs));
  };

  return (
    <nav
      className={`py-4 px-8 ${type !== "hourly_tracking" && type !== "activity" ? "border-b border-b-gray-100" : ""}`}
    >
      <div className={"flex justify-between items-center"}>
        <div className={"capitalize"}>
          {type === "hourly_tracking" ? (
            <div className={"flex gap-2.5 items-center"}>
              <div className={"flex gap-1"}>
                <Button
                  color={"SECONDARY"}
                  size={"SMI"}
                  onClick={onPrevPeriod}
                  name={"header_hourly_tracking_prev_date"}
                >
                    <ChevronLeft wh={16} color={"#374151"} />
                </Button>
                <Button
                  color={"SECONDARY"}
                  size={"SMI"}
                  onClick={onNextPeriod}
                  name={"header_hourly_tracking_next_date"}
                >
                    <ChevronRight wh={16} color={"#374151"} />
                </Button>
              </div>
              <div
                className={
                  "text-2xl font-semibold header_hourly_tracking_date_display"
                }
              >
                {datePeriodLabel(dateStart, dateEnd)}
              </div>
            </div>
          ) : type === "activity" ? (
            <div className={"text-2xl font-semibold"}>Activité</div>
          ) : (
            <>{dateLong(new Date())}</>
          )}
        </div>
        <LogoutNavDesktop />
      </div>
    </nav>
  );
};

export default NavbarSite;
